import { useMemo } from 'react';

export function useScaleData({ rangesPoints }) {
  const calculatedRanges = rangesPoints.reduce((acc, cur, index) => {
    const range = Math.abs(cur - rangesPoints[Math.max(index - 1, 0)]);
    acc.push(range);
    return acc;
  }, []);

  const rangesPrefixSums = calculatedRanges.reduce((acc, cur, index) => {
    acc.push(cur + (acc[index - 1] || 0));
    return acc;
  }, []);

  const sumWidth = rangesPrefixSums[rangesPrefixSums.length - 1];

  return useMemo(() => {
    return { sumWidth, calculatedRanges, rangesPrefixSums };
  }, [rangesPoints, calculatedRanges, rangesPrefixSums, sumWidth]);
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/useScaleData.jsx